export const BASE_URL = "https://ws.latecnologica.com/api//ws-clinicas/photos/";
